
import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';
import Languages from '@locales';

Vue.use(VueLocalStorage);

const supportedLanguages = Object.getOwnPropertyNames(Languages);


export const state = {
  language: Vue.localStorage.get('language'),
}

export const getters = {}

export const mutations = {
  SET_LANGUAGE(state, language) {
    state.language = language
  },
}

export const actions = {

  init({ state, dispatch }) {
  },

  setLanguage({ commit }, {currentLanguage, languages}) {
    const language = supportedLanguages.find(sl =>
      currentLanguage.split(new RegExp(sl, 'gi')).length - 1 > 0 ? sl : null);
    if (language){
      commit('SET_LANGUAGE', language);
    }else if (typeof languages === 'string') {
      commit('SET_LANGUAGE', languages);
    } else {
      const language = supportedLanguages.find(sl =>
        languages.find(l => (l.split(new RegExp(sl, 'gi')).length - 1 > 0 ? sl : null)));
        commit('SET_LANGUAGE', language);
    }
  }
}